<template>
  <div class="layerPop" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">HS-CODE 조회</p>
        </div>
        <div class="popCon">
          <div class="conStyle1">
            <p class="tit mgt0">조건을 선택하세요</p>
          </div>

          <div class="sortWrap mgt30">
            <dl>
              <dt>검색조건</dt>
              <dd>
                <div class="split">
                  <div class="inpSlt">
                    <button type="button" class="sltBtn" title="조건 선택">
                      <span>HS코드</span>
                    </button>
                    <ul>
                      <li
                        v-for="(d, index) in state.hcCodeGubunList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          title="선택"
                          @click="onClickLv1Item(d)"
                        >
                          <span>{{ d.name }}</span>
                        </button>
                      </li>
                      <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                    </ul>
                  </div>
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder=""
                      title=""
                      v-model="state.hsItmNm"
                    />
                  </div>
                </div>
              </dd>
            </dl>
            <button type="button" class="btnSearch" @click="search()">
              <span class="hide">검색</span>
            </button>
          </div>

          <div class="tabStyle2">
            <table>
              <caption>
                조회결과
              </caption>
              <colgroup>
                <col width="100" />
                <col width="*" />
                <col width="*" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col">품목코드</th>
                  <th scope="col">HS코드</th>
                  <th scope="col">설명</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, index) in state.hsCodeOutputVoList" :key="index">
                  <td>
                    <button type="button" @click="send(d.hsCd)">
                      {{ d.itmCd }}
                    </button>
                  </td>
                  <td>
                    <button type="button" @click="send(d.hsCd)">
                      {{ d.hsCd }}
                    </button>
                  </td>
                  <td>
                    <button type="button" @click="send(d.hsCd)">
                      {{ d.hsItmNm }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="send()"><span>확인</span></a>
        </div>
        <slot></slot>
        <button type="button" class="popClose" @click="close()">
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineExpose, reactive, inject } from "vue";
import * as codeList from "@/common/code";
const swalAlert = inject("swalAlert");

const axios = inject("axios");

const state = reactive({
  hcCodeGubunList: codeList.getHcCodeGubunList,
  hsCode: "0",
  hsItmNm: "",
  hsCodeOutputVoList: [],
});

const onClickLv1Item = (d) => {
  state.hsCode = d.code;
};

const search = async () => {
  let param = {
    hsCd: state.hsCode,
    hsItmNm: state.hsItmNm,
  };
  let result = await axios.transaction("FNGCTNFO0002", param);
  let row = result.body.row;
  if(_.isEmpty(row)){
      swalAlert("해당 조건에 맞는 자료가 없습니다.");
  }

  state.hsCodeOutputVoList = row;
};

const isVisible = ref(false);

const emits = defineEmits(["update:data", "close"]);

const open = () => {
  isVisible.value = true;
};

const send = (d) => {
  emits("update:data", d);
  isVisible.value = false;
};

const close = () => {
  isVisible.value = false;
  emits("close");
};

init();

function init() {}

defineExpose({ open, close });
</script>
